import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { ErrorHandlingRoutes } from '@vdms-hq/error-handling';
import { AdminFieldsConfigService } from './logic/admin-fields-config.service';

export const TABLES_AND_LIST_ADMIN_ROUTING: Routes = [
  {
    path: '',
    redirectTo: 'default',
    pathMatch: 'full',
  },
  {
    loadComponent: () =>
      import('./pages/page-settings/page-results-settings.component').then((m) => m.PageResultsSettingsComponent),
    path: ':configKey',
    resolve: {
      config: AdminFieldsConfigService,
    },
    canDeactivate: [
      /**
       * Resets the stored side menu state when the user navigates away from the
       * tables-and-lists admin section
       */
      () => {
        inject(AdminFieldsConfigService).reset();
        return true;
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/error/' + ErrorHandlingRoutes.NOT_FOUND,
  },
];
